import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuItemRelations`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuItemRelations`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/menuItemRelations/${id}`,
		payload
	);
};

const update = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/menuItemRelations/${id}`,
		payload
	);
};

const remove = (merchantId, id, payload) => {
	return Client.del(
		`${baseUrl}/${merchantId}/menuItemRelations/${id}`,
		payload
	);
};

// 获取某个分类菜品全部层级的信息
const submenuLinkRelation = (merchantId, itemCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/submenu-link-relation/${itemCode}`,
		payload
	);
};

// 查询菜品附加信息关系
const instructionRelation = (merchantId, itemCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/menu-item-relate/${itemCode}`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	submenuLinkRelation,
	instructionRelation,
};
